export var getEnvironment = function () {
    var host = window.location.host;
    var isStage = host.includes('-stage');
    var isLocalhost = host.includes('localhost');
    var isProd = !isStage && !isLocalhost;
    return {
        isStage: isStage,
        isLocalhost: isLocalhost,
        isProd: isProd
    };
};
//# sourceMappingURL=getEnvironment.js.map